(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-delivery-form"] && !Shopify.designMode) return;
  try {
    
(function() {
  var SUBURBS = [
    {suburb:"Aberfoyle Park",postcode:"5159",zone:"E",price:"$53.00"},
    {suburb:"Adelaide",postcode:"5000",zone:"A",price:"$20.00"},
    {suburb:"Adelaide Airport",postcode:"5950",zone:"B",price:"$27.00"},
    {suburb:"Albert Park",postcode:"5014",zone:"C",price:"$35.00"},
    {suburb:"Alberton",postcode:"5014",zone:"C",price:"$35.00"},
    {suburb:"Aldgate",postcode:"5154",zone:"D",price:"$47.00"},
    {suburb:"Allenby Gardens",postcode:"5009",zone:"B",price:"$27.00"},
    {suburb:"Andrews Farm",postcode:"5114",zone:"G",price:"$79.00"},
    {suburb:"Angle Park",postcode:"5010",zone:"B",price:"$27.00"},
    {suburb:"Angle Vale",postcode:"5117",zone:"H",price:"$90.00"},
    {suburb:"Ascot Park",postcode:"5043",zone:"B",price:"$27.00"},
    {suburb:"Ashford",postcode:"5035",zone:"A",price:"$20.00"},
    {suburb:"Athelstone",postcode:"5076",zone:"C",price:"$35.00"},
    {suburb:"Athol Park",postcode:"5012",zone:"B",price:"$27.00"},
    {suburb:"Auldana",postcode:"5072",zone:"B",price:"$27.00"},
    {suburb:"Balhannah",postcode:"5242",zone:"E",price:"$53.00"},
    {suburb:"Banksia Park",postcode:"5091",zone:"D",price:"$47.00"},
    {suburb:"Beaumont",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Bedford Park",postcode:"5042",zone:"B",price:"$27.00"},
    {suburb:"Belair",postcode:"5052",zone:"C",price:"$35.00"},
    {suburb:"Bellevue Heights",postcode:"5050",zone:"C",price:"$35.00"},
    {suburb:"Beulah Park",postcode:"5067",zone:"A",price:"$20.00"},
    {suburb:"Beverley",postcode:"5009",zone:"B",price:"$27.00"},
    {suburb:"Birkenhead",postcode:"5015",zone:"D",price:"$47.00"},
    {suburb:"Black Forest",postcode:"5035",zone:"A",price:"$20.00"},
    {suburb:"Blackwood",postcode:"5051",zone:"C",price:"$35.00"},
    {suburb:"Blair Athol",postcode:"5084",zone:"B",price:"$27.00"},
    {suburb:"Blakeview",postcode:"5114",zone:"G",price:"$79.00"},
    {suburb:"Blakiston",postcode:"5250",zone:"G",price:"$79.00"},
    {suburb:"Bolivar",postcode:"5110",zone:"E",price:"$53.00"},
    {suburb:"Bowden",postcode:"5007",zone:"B",price:"$27.00"},
    {suburb:"Brahma Lodge",postcode:"5109",zone:"E",price:"$53.00"},
    {suburb:"Bridgewater",postcode:"5155",zone:"E",price:"$53.00"},
    {suburb:"Brighton",postcode:"5048",zone:"C",price:"$35.00"},
    {suburb:"Broadview",postcode:"5083",zone:"B",price:"$27.00"},
    {suburb:"Brompton",postcode:"5007",zone:"B",price:"$27.00"},
    {suburb:"Brooklyn Park",postcode:"5032",zone:"B",price:"$27.00"},
    {suburb:"Brown Hill Creek",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Burnside",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Burton",postcode:"5110",zone:"E",price:"$53.00"},
    {suburb:"Camden Park",postcode:"5038",zone:"B",price:"$27.00"},
    {suburb:"Campbelltown",postcode:"5074",zone:"B",price:"$27.00"},
    {suburb:"Cavan",postcode:"5094",zone:"C",price:"$35.00"},
    {suburb:"Charleston",postcode:"5244",zone:"H",price:"$90.00"},
    {suburb:"Cheltenham",postcode:"5014",zone:"C",price:"$35.00"},
    {suburb:"Christie Downs",postcode:"5164",zone:"F",price:"$67.00"},
    {suburb:"Christies Beach",postcode:"5165",zone:"F",price:"$67.00"},
    {suburb:"Clapham",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Clarence Gardens",postcode:"5039",zone:"B",price:"$27.00"},
    {suburb:"Clarence Park",postcode:"5034",zone:"A",price:"$20.00"},
    {suburb:"Clearview",postcode:"5085",zone:"B",price:"$27.00"},
    {suburb:"Cleland",postcode:"5152",zone:"D",price:"$47.00"},
    {suburb:"Clovelly Park",postcode:"5042",zone:"B",price:"$27.00"},
    {suburb:"College Park",postcode:"5069",zone:"A",price:"$20.00"},
    {suburb:"Collinswood",postcode:"5081",zone:"B",price:"$27.00"},
    {suburb:"Colonel Light Gardens",postcode:"5041",zone:"B",price:"$27.00"},
    {suburb:"Coromandel Valley",postcode:"5051",zone:"C",price:"$35.00"},
    {suburb:"Cowandilla",postcode:"5033",zone:"A",price:"$20.00"},
    {suburb:"Crafers",postcode:"5152",zone:"D",price:"$47.00"},
    {suburb:"Crafers West",postcode:"5152",zone:"D",price:"$47.00"},
    {suburb:"Craigburn Farm",postcode:"5051",zone:"C",price:"$35.00"},
    {suburb:"Craigmore",postcode:"5114",zone:"G",price:"$79.00"},
    {suburb:"Croydon",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"Croydon Park",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"Cumberland Park",postcode:"5041",zone:"B",price:"$27.00"},
    {suburb:"Darlington",postcode:"5047",zone:"C",price:"$35.00"},
    {suburb:"Davoren Park",postcode:"5113",zone:"F",price:"$67.00"},
    {suburb:"Daw Park",postcode:"5041",zone:"B",price:"$27.00"},
    {suburb:"Dernancourt",postcode:"5075",zone:"C",price:"$35.00"},
    {suburb:"Devon Park",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"Direk",postcode:"5110",zone:"E",price:"$53.00"},
    {suburb:"Dover Gardens",postcode:"5048",zone:"C",price:"$35.00"},
    {suburb:"Dry Creek",postcode:"5094",zone:"C",price:"$35.00"},
    {suburb:"Dudley Park",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"Dulwich",postcode:"5065",zone:"A",price:"$20.00"},
    {suburb:"Eastwood",postcode:"5063",zone:"A",price:"$20.00"},
    {suburb:"Eden Hills",postcode:"5050",zone:"C",price:"$35.00"},
    {suburb:"Edinburgh",postcode:"5111",zone:"F",price:"$67.00"},
    {suburb:"Edinburgh North",postcode:"5113",zone:"F",price:"$67.00"},
    {suburb:"Edwardstown",postcode:"5039",zone:"B",price:"$27.00"},
    {suburb:"Elizabeth",postcode:"5112",zone:"E",price:"$53.00"},
    {suburb:"Elizabeth Downs",postcode:"5113",zone:"F",price:"$67.00"},
    {suburb:"Elizabeth East",postcode:"5112",zone:"E",price:"$53.00"},
    {suburb:"Elizabeth Grove",postcode:"5112",zone:"E",price:"$53.00"},
    {suburb:"Elizabeth North",postcode:"5113",zone:"F",price:"$67.00"},
    {suburb:"Elizabeth Park",postcode:"5113",zone:"F",price:"$67.00"},
    {suburb:"Elizabeth South",postcode:"5112",zone:"E",price:"$53.00"},
    {suburb:"Elizabeth Vale",postcode:"5112",zone:"E",price:"$53.00"},
    {suburb:"Enfield",postcode:"5085",zone:"B",price:"$27.00"},
    {suburb:"Erindale",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Ethelton",postcode:"5015",zone:"D",price:"$47.00"},
    {suburb:"Evandale",postcode:"5069",zone:"A",price:"$20.00"},
    {suburb:"Evanston",postcode:"5116",zone:"H",price:"$90.00"},
    {suburb:"Evanston Gardens",postcode:"5116",zone:"H",price:"$90.00"},
    {suburb:"Evanston Park",postcode:"5116",zone:"H",price:"$90.00"},
    {suburb:"Evanston South",postcode:"5116",zone:"H",price:"$90.00"},
    {suburb:"Everard Park",postcode:"5035",zone:"A",price:"$20.00"},
    {suburb:"Exeter",postcode:"5019",zone:"D",price:"$47.00"},
    {suburb:"Fairview Park",postcode:"5126",zone:"D",price:"$47.00"},
    {suburb:"Felixstow",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Ferryden Park",postcode:"5010",zone:"B",price:"$27.00"},
    {suburb:"Findon",postcode:"5023",zone:"B",price:"$27.00"},
    {suburb:"Firle",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Fitzroy",postcode:"5082",zone:"A",price:"$20.00"},
    {suburb:"Flagstaff Hill",postcode:"5159",zone:"E",price:"$53.00"},
    {suburb:"Flinders Park",postcode:"5025",zone:"B",price:"$27.00"},
    {suburb:"Flinders University",postcode:"5042",zone:"B",price:"$27.00"},
    {suburb:"Forestville",postcode:"5035",zone:"A",price:"$20.00"},
    {suburb:"Frewville",postcode:"5063",zone:"A",price:"$20.00"},
    {suburb:"Fulham",postcode:"5024",zone:"B",price:"$27.00"},
    {suburb:"Fulham Gardens",postcode:"5024",zone:"B",price:"$27.00"},
    {suburb:"Fullarton",postcode:"5063",zone:"A",price:"$20.00"},
    {suburb:"Gawler",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Gawler East",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Gawler South",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Gawler West",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Gepps Cross",postcode:"5094",zone:"C",price:"$35.00"},
    {suburb:"Gilberton",postcode:"5081",zone:"B",price:"$27.00"},
    {suburb:"Gilles Plains",postcode:"5086",zone:"B",price:"$27.00"},
    {suburb:"Gillman",postcode:"5013",zone:"C",price:"$35.00"},
    {suburb:"Glandore",postcode:"5037",zone:"B",price:"$27.00"},
    {suburb:"Glanville",postcode:"5015",zone:"D",price:"$47.00"},
    {suburb:"Glen Osmond",postcode:"5064",zone:"B",price:"$27.00"},
    {suburb:"Glenalta",postcode:"5052",zone:"C",price:"$35.00"},
    {suburb:"Glenelg",postcode:"5045",zone:"C",price:"$35.00"},
    {suburb:"Glenelg East",postcode:"5045",zone:"C",price:"$35.00"},
    {suburb:"Glenelg North",postcode:"5045",zone:"C",price:"$35.00"},
    {suburb:"Glenelg South",postcode:"5045",zone:"C",price:"$35.00"},
    {suburb:"Glengowrie",postcode:"5044",zone:"C",price:"$35.00"},
    {suburb:"Glenside",postcode:"5065",zone:"A",price:"$20.00"},
    {suburb:"Glenunga",postcode:"5064",zone:"B",price:"$27.00"},
    {suburb:"Globe Derby Park",postcode:"5110",zone:"E",price:"$53.00"},
    {suburb:"Glynde",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Golden Grove",postcode:"5125",zone:"E",price:"$53.00"},
    {suburb:"Goodwood",postcode:"5034",zone:"A",price:"$20.00"},
    {suburb:"Grange",postcode:"5022",zone:"C",price:"$35.00"},
    {suburb:"Green Fields",postcode:"5107",zone:"D",price:"$47.00"},
    {suburb:"Greenacres",postcode:"5086",zone:"B",price:"$27.00"},
    {suburb:"Greenhill",postcode:"5140",zone:"B",price:"$27.00"},
    {suburb:"Greenwith",postcode:"5125",zone:"E",price:"$53.00"},
    {suburb:"Gulfview Heights",postcode:"5096",zone:"D",price:"$47.00"},
    {suburb:"Hackham",postcode:"5163",zone:"F",price:"$67.00"},
    {suburb:"Hackham West",postcode:"5163",zone:"F",price:"$67.00"},
    {suburb:"Hackney",postcode:"5069",zone:"A",price:"$20.00"},
    {suburb:"Hahndorf",postcode:"5245",zone:"E",price:"$53.00"},
    {suburb:"Hallett Cove",postcode:"5158",zone:"D",price:"$47.00"},
    {suburb:"Hampstead Gardens",postcode:"5086",zone:"B",price:"$27.00"},
    {suburb:"Happy Valley",postcode:"5159",zone:"E",price:"$53.00"},
    {suburb:"Harrogate",postcode:"5244",zone:"H",price:"$90.00"},
    {suburb:"Hawthorn",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Hawthorndene",postcode:"5051",zone:"C",price:"$35.00"},
    {suburb:"Hazelwood Park",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Heathfield",postcode:"5153",zone:"D",price:"$47.00"},
    {suburb:"Heathpool",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Hectorville",postcode:"5073",zone:"B",price:"$27.00"},
    {suburb:"Hendon",postcode:"5014",zone:"C",price:"$35.00"},
    {suburb:"Henley Beach",postcode:"5022",zone:"C",price:"$35.00"},
    {suburb:"Henley Beach South",postcode:"5022",zone:"C",price:"$35.00"},
    {suburb:"Hewett",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Highbury",postcode:"5089",zone:"C",price:"$35.00"},
    {suburb:"Highgate",postcode:"5063",zone:"A",price:"$20.00"},
    {suburb:"Hillbank",postcode:"5112",zone:"E",price:"$53.00"},
    {suburb:"Hillcrest",postcode:"5086",zone:"B",price:"$27.00"},
    {suburb:"Hilton",postcode:"5033",zone:"A",price:"$20.00"},
    {suburb:"Hindmarsh",postcode:"5007",zone:"B",price:"$27.00"},
    {suburb:"Holden Hill",postcode:"5088",zone:"C",price:"$35.00"},
    {suburb:"Hope Valley",postcode:"5090",zone:"C",price:"$35.00"},
    {suburb:"Hove",postcode:"5048",zone:"C",price:"$35.00"},
    {suburb:"Huntfield Heights",postcode:"5163",zone:"F",price:"$67.00"},
    {suburb:"Hyde Park",postcode:"5061",zone:"A",price:"$20.00"},
    {suburb:"Ingle Farm",postcode:"5098",zone:"C",price:"$35.00"},
    {suburb:"Inverbrackie",postcode:"5244",zone:"H",price:"$90.00"},
    {suburb:"Ironbank",postcode:"5153",zone:"D",price:"$47.00"},
    {suburb:"Joslin",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Kensington",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Kensington Gardens",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Kensington Park",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Kent Town",postcode:"5067",zone:"A",price:"$20.00"},
    {suburb:"Keswick",postcode:"5035",zone:"A",price:"$20.00"},
    {suburb:"Kidman Park",postcode:"5025",zone:"B",price:"$27.00"},
    {suburb:"Kilburn",postcode:"5084",zone:"B",price:"$27.00"},
    {suburb:"Kilkenny",postcode:"5009",zone:"B",price:"$27.00"},
    {suburb:"Kings Park",postcode:"5034",zone:"A",price:"$20.00"},
    {suburb:"Kingston Park",postcode:"5049",zone:"D",price:"$47.00"},
    {suburb:"Kingswood",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Klemzig",postcode:"5087",zone:"B",price:"$27.00"},
    {suburb:"Kudla",postcode:"5115",zone:"G",price:"$79.00"},
    {suburb:"Kurralta Park",postcode:"5037",zone:"B",price:"$27.00"},
    {suburb:"Largs Bay",postcode:"5016",zone:"D",price:"$47.00"},
    {suburb:"Largs North",postcode:"5016",zone:"D",price:"$47.00"},
    {suburb:"Leabrook",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Leawood Gardens",postcode:"5150",zone:"B",price:"$27.00"},
    {suburb:"Lenswood",postcode:"5240",zone:"E",price:"$53.00"},
    {suburb:"Lewiston",postcode:"5501",zone:"H",price:"$90.00"},
    {suburb:"Lightsview",postcode:"5085",zone:"B",price:"$27.00"},
    {suburb:"Linden Park",postcode:"5065",zone:"A",price:"$20.00"},
    {suburb:"Littlehampton",postcode:"5250",zone:"G",price:"$79.00"},
    {suburb:"Lockleys",postcode:"5032",zone:"B",price:"$27.00"},
    {suburb:"Longwood",postcode:"5153",zone:"D",price:"$47.00"},
    {suburb:"Lonsdale",postcode:"5160",zone:"E",price:"$53.00"},
    {suburb:"Lower Mitcham",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Lynton",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Magill",postcode:"5072",zone:"B",price:"$27.00"},
    {suburb:"Malvern",postcode:"5061",zone:"A",price:"$20.00"},
    {suburb:"Manningham",postcode:"5086",zone:"B",price:"$27.00"},
    {suburb:"Mansfield Park",postcode:"5012",zone:"B",price:"$27.00"},
    {suburb:"Marden",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Marino",postcode:"5049",zone:"D",price:"$47.00"},
    {suburb:"Marion",postcode:"5043",zone:"B",price:"$27.00"},
    {suburb:"Marleston",postcode:"5033",zone:"A",price:"$20.00"},
    {suburb:"Marryatville",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Mawson Lakes",postcode:"5095",zone:"C",price:"$35.00"},
    {suburb:"Maylands",postcode:"5069",zone:"A",price:"$20.00"},
    {suburb:"Medindie",postcode:"5081",zone:"B",price:"$27.00"},
    {suburb:"Medindie Gardens",postcode:"5081",zone:"B",price:"$27.00"},
    {suburb:"Melrose Park",postcode:"5039",zone:"B",price:"$27.00"},
    {suburb:"Mile End",postcode:"5031",zone:"A",price:"$20.00"},
    {suburb:"Mile End South",postcode:"5031",zone:"A",price:"$20.00"},
    {suburb:"Millswood",postcode:"5034",zone:"A",price:"$20.00"},
    {suburb:"Mitcham",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Mitchell Park",postcode:"5043",zone:"B",price:"$27.00"},
    {suburb:"Modbury",postcode:"5092",zone:"D",price:"$47.00"},
    {suburb:"Modbury Heights",postcode:"5092",zone:"D",price:"$47.00"},
    {suburb:"Modbury North",postcode:"5092",zone:"D",price:"$47.00"},
    {suburb:"Montacute",postcode:"5134",zone:"D",price:"$47.00"},
    {suburb:"Morphett Vale",postcode:"5162",zone:"E",price:"$53.00"},
    {suburb:"Morphettville",postcode:"5043",zone:"B",price:"$27.00"},
    {suburb:"Mount Barker",postcode:"5251",zone:"I",price:"$83.00"},
    {suburb:"Mount Barker Junction",postcode:"5251",zone:"I",price:"$83.00"},
    {suburb:"Mount Barker Springs",postcode:"5251",zone:"I",price:"$83.00"},
    {suburb:"Mount Barker Summit",postcode:"5251",zone:"I",price:"$83.00"},
    {suburb:"Mount Osmond",postcode:"5064",zone:"B",price:"$27.00"},
    {suburb:"Munno Para",postcode:"5115",zone:"G",price:"$79.00"},
    {suburb:"Munno Para Downs",postcode:"5115",zone:"G",price:"$79.00"},
    {suburb:"Munno Para West",postcode:"5115",zone:"G",price:"$79.00"},
    {suburb:"Mylor",postcode:"5153",zone:"D",price:"$47.00"},
    {suburb:"Myrtle Bank",postcode:"5064",zone:"B",price:"$27.00"},
    {suburb:"Nailsworth",postcode:"5083",zone:"B",price:"$27.00"},
    {suburb:"Nairne",postcode:"5252",zone:"G",price:"$79.00"},
    {suburb:"Netherby",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Netley",postcode:"5037",zone:"B",price:"$27.00"},
    {suburb:"New Port",postcode:"5015",zone:"D",price:"$47.00"},
    {suburb:"Newton",postcode:"5074",zone:"B",price:"$27.00"},
    {suburb:"Noarlunga Centre",postcode:"5168",zone:"F",price:"$67.00"},
    {suburb:"Noarlunga Downs",postcode:"5168",zone:"F",price:"$67.00"},
    {suburb:"North Adelaide",postcode:"5006",zone:"A",price:"$20.00"},
    {suburb:"North Brighton",postcode:"5048",zone:"C",price:"$35.00"},
    {suburb:"North Haven",postcode:"5018",zone:"E",price:"$53.00"},
    {suburb:"North Plympton",postcode:"5037",zone:"B",price:"$27.00"},
    {suburb:"Northfield",postcode:"5085",zone:"B",price:"$27.00"},
    {suburb:"Northgate",postcode:"5085",zone:"B",price:"$27.00"},
    {suburb:"Norton Summit",postcode:"5136",zone:"C",price:"$35.00"},
    {suburb:"Norwood",postcode:"5067",zone:"A",price:"$20.00"},
    {suburb:"Novar Gardens",postcode:"5040",zone:"B",price:"$27.00"},
    {suburb:"O'Halloran Hill",postcode:"5158",zone:"D",price:"$47.00"},
    {suburb:"O'Sullivan Beach",postcode:"5166",zone:"F",price:"$67.00"},
    {suburb:"Oakbank",postcode:"5243",zone:"F",price:"$67.00"},
    {suburb:"Oakden",postcode:"5086",zone:"B",price:"$27.00"},
    {suburb:"Oaklands Park",postcode:"5046",zone:"C",price:"$35.00"},
    {suburb:"Old Noarlunga",postcode:"5168",zone:"F",price:"$67.00"},
    {suburb:"Old Reynella",postcode:"5161",zone:"E",price:"$53.00"},
    {suburb:"Onkaparinga Hills",postcode:"5163",zone:"F",price:"$67.00"},
    {suburb:"Osborne",postcode:"5017",zone:"D",price:"$47.00"},
    {suburb:"Ottoway",postcode:"5013",zone:"C",price:"$35.00"},
    {suburb:"Outer Harbor",postcode:"5018",zone:"E",price:"$53.00"},
    {suburb:"Ovingham",postcode:"5082",zone:"A",price:"$20.00"},
    {suburb:"Paechtown",postcode:"5245",zone:"E",price:"$53.00"},
    {suburb:"Panorama",postcode:"5041",zone:"B",price:"$27.00"},
    {suburb:"Para Hills",postcode:"5096",zone:"D",price:"$47.00"},
    {suburb:"Para Hills West",postcode:"5096",zone:"D",price:"$47.00"},
    {suburb:"Para Vista",postcode:"5093",zone:"C",price:"$35.00"},
    {suburb:"Paradise",postcode:"5075",zone:"C",price:"$35.00"},
    {suburb:"Parafield",postcode:"5106",zone:"D",price:"$47.00"},
    {suburb:"Parafield Gardens",postcode:"5107",zone:"D",price:"$47.00"},
    {suburb:"Paralowie",postcode:"5108",zone:"E",price:"$53.00"},
    {suburb:"Park Holme",postcode:"5043",zone:"B",price:"$27.00"},
    {suburb:"Parkside",postcode:"5063",zone:"A",price:"$20.00"},
    {suburb:"Pasadena",postcode:"5042",zone:"B",price:"$27.00"},
    {suburb:"Payneham",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Payneham South",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Penfield",postcode:"5121",zone:"F",price:"$67.00"},
    {suburb:"Penfield Gardens",postcode:"5121",zone:"F",price:"$67.00"},
    {suburb:"Pennington",postcode:"5013",zone:"C",price:"$35.00"},
    {suburb:"Peterhead",postcode:"5016",zone:"D",price:"$47.00"},
    {suburb:"Piccadilly",postcode:"5151",zone:"D",price:"$47.00"},
    {suburb:"Plympton",postcode:"5038",zone:"B",price:"$27.00"},
    {suburb:"Plympton Park",postcode:"5038",zone:"B",price:"$27.00"},
    {suburb:"Pooraka",postcode:"5095",zone:"C",price:"$35.00"},
    {suburb:"Port Adelaide",postcode:"5015",zone:"D",price:"$47.00"},
    {suburb:"Port Noarlunga",postcode:"5167",zone:"F",price:"$67.00"},
    {suburb:"Port Noarlunga South",postcode:"5167",zone:"F",price:"$67.00"},
    {suburb:"Prospect",postcode:"5082",zone:"A",price:"$20.00"},
    {suburb:"Queenstown",postcode:"5014",zone:"C",price:"$35.00"},
    {suburb:"Redwood Park",postcode:"5097",zone:"D",price:"$47.00"},
    {suburb:"Regency Park",postcode:"5010",zone:"B",price:"$27.00"},
    {suburb:"Reid",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Renown Park",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"Reynella",postcode:"5161",zone:"E",price:"$53.00"},
    {suburb:"Reynella East",postcode:"5161",zone:"E",price:"$53.00"},
    {suburb:"Richmond",postcode:"5033",zone:"A",price:"$20.00"},
    {suburb:"Ridgehaven",postcode:"5097",zone:"D",price:"$47.00"},
    {suburb:"Ridleyton",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"Rose Park",postcode:"5067",zone:"A",price:"$20.00"},
    {suburb:"Rosewater",postcode:"5013",zone:"C",price:"$35.00"},
    {suburb:"Rosewater East",postcode:"5013",zone:"C",price:"$35.00"},
    {suburb:"Rosslyn Park",postcode:"5072",zone:"B",price:"$27.00"},
    {suburb:"Rostrevor",postcode:"5073",zone:"B",price:"$27.00"},
    {suburb:"Royal Park",postcode:"5014",zone:"C",price:"$35.00"},
    {suburb:"Royston Park",postcode:"5070",zone:"B",price:"$27.00"},
    {suburb:"Salisbury",postcode:"5108",zone:"E",price:"$53.00"},
    {suburb:"Salisbury Downs",postcode:"5108",zone:"E",price:"$53.00"},
    {suburb:"Salisbury East",postcode:"5109",zone:"E",price:"$53.00"},
    {suburb:"Salisbury Heights",postcode:"5109",zone:"E",price:"$53.00"},
    {suburb:"Salisbury North",postcode:"5108",zone:"E",price:"$53.00"},
    {suburb:"Salisbury Park",postcode:"5109",zone:"E",price:"$53.00"},
    {suburb:"Salisbury Plain",postcode:"5109",zone:"E",price:"$53.00"},
    {suburb:"Salisbury South",postcode:"5106",zone:"D",price:"$47.00"},
    {suburb:"Seacliff",postcode:"5049",zone:"D",price:"$47.00"},
    {suburb:"Seacliff Park",postcode:"5049",zone:"D",price:"$47.00"},
    {suburb:"Seacombe Gardens",postcode:"5047",zone:"C",price:"$35.00"},
    {suburb:"Seacombe Heights",postcode:"5047",zone:"C",price:"$35.00"},
    {suburb:"Seaford",postcode:"5169",zone:"H",price:"$90.00"},
    {suburb:"Seaford Heights",postcode:"5169",zone:"H",price:"$90.00"},
    {suburb:"Seaford Meadows",postcode:"5169",zone:"H",price:"$90.00"},
    {suburb:"Seaford Rise",postcode:"5169",zone:"H",price:"$90.00"},
    {suburb:"Seaton",postcode:"5023",zone:"B",price:"$27.00"},
    {suburb:"Seaview Downs",postcode:"5049",zone:"D",price:"$47.00"},
    {suburb:"Sefton Park",postcode:"5083",zone:"B",price:"$27.00"},
    {suburb:"Semaphore",postcode:"5019",zone:"D",price:"$47.00"},
    {suburb:"Semaphore Park",postcode:"5019",zone:"D",price:"$47.00"},
    {suburb:"Semaphore South",postcode:"5019",zone:"D",price:"$47.00"},
    {suburb:"Sheidow Park",postcode:"5158",zone:"D",price:"$47.00"},
    {suburb:"Skye",postcode:"5072",zone:"B",price:"$27.00"},
    {suburb:"Smithfield",postcode:"5114",zone:"G",price:"$79.00"},
    {suburb:"Smithfield Plains",postcode:"5114",zone:"G",price:"$79.00"},
    {suburb:"Smithfield West",postcode:"5114",zone:"G",price:"$79.00"},
    {suburb:"Somerton Park",postcode:"5044",zone:"C",price:"$35.00"},
    {suburb:"South Brighton",postcode:"5048",zone:"C",price:"$35.00"},
    {suburb:"South Plympton",postcode:"5038",zone:"B",price:"$27.00"},
    {suburb:"Springfield",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"St Agnes",postcode:"5097",zone:"D",price:"$47.00"},
    {suburb:"St Clair",postcode:"5011",zone:"B",price:"$27.00"},
    {suburb:"St Georges",postcode:"5064",zone:"B",price:"$27.00"},
    {suburb:"St Kilda",postcode:"5110",zone:"E",price:"$53.00"},
    {suburb:"St Marys",postcode:"5042",zone:"B",price:"$27.00"},
    {suburb:"St Morris",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"St Peters",postcode:"5069",zone:"A",price:"$20.00"},
    {suburb:"Stepney",postcode:"5069",zone:"A",price:"$20.00"},
    {suburb:"Stirling",postcode:"5152",zone:"D",price:"$47.00"},
    {suburb:"Stonyfell",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Sturt",postcode:"5047",zone:"C",price:"$35.00"},
    {suburb:"Summertown",postcode:"5141",zone:"C",price:"$35.00"},
    {suburb:"Surrey Downs",postcode:"5126",zone:"D",price:"$47.00"},
    {suburb:"Taperoo",postcode:"5017",zone:"D",price:"$47.00"},
    {suburb:"Tea Tree Gully",postcode:"5091",zone:"D",price:"$47.00"},
    {suburb:"Tennyson",postcode:"5022",zone:"C",price:"$35.00"},
    {suburb:"Teringie",postcode:"5072",zone:"B",price:"$27.00"},
    {suburb:"Thebarton",postcode:"5031",zone:"A",price:"$20.00"},
    {suburb:"Thorngate",postcode:"5082",zone:"A",price:"$20.00"},
    {suburb:"Tonsley",postcode:"5042",zone:"B",price:"$27.00"},
    {suburb:"Toorak Gardens",postcode:"5065",zone:"A",price:"$20.00"},
    {suburb:"Torrens Park",postcode:"5062",zone:"B",price:"$27.00"},
    {suburb:"Torrensville",postcode:"5031",zone:"A",price:"$20.00"},
    {suburb:"Totness",postcode:"5250",zone:"G",price:"$79.00"},
    {suburb:"Tranmere",postcode:"5073",zone:"B",price:"$27.00"},
    {suburb:"Trinity Gardens",postcode:"5068",zone:"B",price:"$27.00"},
    {suburb:"Trott Park",postcode:"5158",zone:"D",price:"$47.00"},
    {suburb:"Tusmore",postcode:"5065",zone:"A",price:"$20.00"},
    {suburb:"Underdale",postcode:"5032",zone:"B",price:"$27.00"},
    {suburb:"Unley",postcode:"5061",zone:"A",price:"$20.00"},
    {suburb:"Unley Park",postcode:"5061",zone:"A",price:"$20.00"},
    {suburb:"Upper Hermitage",postcode:"5131",zone:"E",price:"$53.00"},
    {suburb:"Upper Sturt",postcode:"5156",zone:"D",price:"$47.00"},
    {suburb:"Uraidla",postcode:"5142",zone:"C",price:"$35.00"},
    {suburb:"Urrbrae",postcode:"5064",zone:"B",price:"$27.00"},
    {suburb:"Vale Park",postcode:"5081",zone:"B",price:"$27.00"},
    {suburb:"Valley View",postcode:"5093",zone:"C",price:"$35.00"},
    {suburb:"Verdun",postcode:"5245",zone:"E",price:"$53.00"},
    {suburb:"Virginia",postcode:"5120",zone:"G",price:"$79.00"},
    {suburb:"Vista",postcode:"5091",zone:"D",price:"$47.00"},
    {suburb:"Walkerville",postcode:"5081",zone:"B",price:"$27.00"},
    {suburb:"Walkley Heights",postcode:"5098",zone:"C",price:"$35.00"},
    {suburb:"Warradale",postcode:"5046",zone:"C",price:"$35.00"},
    {suburb:"Warradale North",postcode:"5046",zone:"C",price:"$35.00"},
    {suburb:"Waterfall Gully",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Waterloo Corner",postcode:"5110",zone:"E",price:"$53.00"},
    {suburb:"Wattle Park",postcode:"5066",zone:"B",price:"$27.00"},
    {suburb:"Wayville",postcode:"5034",zone:"A",price:"$20.00"},
    {suburb:"Welland",postcode:"5007",zone:"B",price:"$27.00"},
    {suburb:"West Beach",postcode:"5024",zone:"B",price:"$27.00"},
    {suburb:"West Croydon",postcode:"5008",zone:"B",price:"$27.00"},
    {suburb:"West Hindmarsh",postcode:"5007",zone:"B",price:"$27.00"},
    {suburb:"West Lakes",postcode:"5021",zone:"C",price:"$35.00"},
    {suburb:"West Lakes Shore",postcode:"5020",zone:"C",price:"$35.00"},
    {suburb:"West Richmond",postcode:"5033",zone:"A",price:"$20.00"},
    {suburb:"Westbourne Park",postcode:"5041",zone:"B",price:"$27.00"},
    {suburb:"Willaston",postcode:"5118",zone:"K",price:"$99.00"},
    {suburb:"Windsor Gardens",postcode:"5087",zone:"B",price:"$27.00"},
    {suburb:"Wingfield",postcode:"5013",zone:"C",price:"$35.00"},
    {suburb:"Wistow",postcode:"5251",zone:"I",price:"$83.00"},
    {suburb:"Woodcroft",postcode:"5162",zone:"E",price:"$53.00"},
    {suburb:"Woodforde",postcode:"5072",zone:"B",price:"$27.00"},
    {suburb:"Woodside",postcode:"5244",zone:"H",price:"$90.00"},
    {suburb:"Woodville",postcode:"5011",zone:"B",price:"$27.00"},
    {suburb:"Woodville Gardens",postcode:"5012",zone:"B",price:"$27.00"},
    {suburb:"Woodville North",postcode:"5012",zone:"B",price:"$27.00"},
    {suburb:"Woodville Park",postcode:"5011",zone:"B",price:"$27.00"},
    {suburb:"Woodville South",postcode:"5011",zone:"B",price:"$27.00"},
    {suburb:"Woodville West",postcode:"5011",zone:"B",price:"$27.00"},
    {suburb:"Wynn Vale",postcode:"5127",zone:"D",price:"$47.00"},
    {suburb:"Yatala Vale",postcode:"5126",zone:"D",price:"$47.00"}
  ];

  function hbSuburbSearch(val) {
    var dd = document.getElementById('hb-suburb-dropdown');
    var cost = document.getElementById('hb-delivery-cost');
    if (!dd) return;
    if (val.length < 2) { dd.style.display = 'none'; cost.classList.remove('hb-show'); return; }
    var matches = SUBURBS.filter(function(s) { return s.suburb.toLowerCase().startsWith(val.toLowerCase()); }).slice(0, 8);
    if (!matches.length) { dd.style.display = 'none'; return; }
    dd.innerHTML = matches.map(function(s) {
      return '<div class="hb-suburb-opt" data-suburb="' + s.suburb + '" data-postcode="' + s.postcode + '" data-zone="' + s.zone + '" data-price="' + s.price + '">' + s.suburb + ' <span>' + s.postcode + ' &middot; ' + s.price + '</span></div>';
    }).join('');
    dd.style.display = 'block';
    dd.querySelectorAll('.hb-suburb-opt').forEach(function(opt) {
      opt.addEventListener('click', function() {
        hbSelectSuburb(opt.dataset.suburb, opt.dataset.postcode, opt.dataset.zone, opt.dataset.price);
      });
    });
  }

  function hbSelectSuburb(suburb, postcode, zone, price) {
    var input = document.getElementById('hb-suburb-input');
    var dd = document.getElementById('hb-suburb-dropdown');
    var pcField = document.getElementById('hb-postcode-field');
    var cost = document.getElementById('hb-delivery-cost');
    if (input) { input.value = suburb; input.classList.remove('hb-finput--error'); }
    if (dd) dd.style.display = 'none';
    var suburbErrEl = document.getElementById('hb-suburb-error');
    if (suburbErrEl) suburbErrEl.remove();
    if (pcField) pcField.value = postcode;
    if (cost) {
      document.getElementById('hb-delivery-zone-label').textContent = suburb + ' — Zone ' + zone;
      document.getElementById('hb-delivery-price').textContent = price;
      cost.classList.add('hb-show');
    }
    hbSelectedZone = zone;
    hbSelectedPrice = price;
  }

  var hbPickupSlot = null;
  var hbSelectedZone = null;
  var hbSelectedPrice = null;

  function hbClearPickupSlot() {
    hbPickupSlot = null;
    var el = document.getElementById('hb-pickup-time-value');
    if (el) el.value = '';
  }

  function hbSetType(type, btn) {
    document.querySelectorAll('.hb-del-btn').forEach(function(b) { b.classList.remove('hb-del-btn--active'); });
    btn.classList.add('hb-del-btn--active');
    var typeInput = document.getElementById('hb-order-type');
    if (typeInput) typeInput.value = type === 'delivery' ? 'Delivery' : 'Pickup in Store';
    var isPickup = type === 'pickup';
    ['hb-addr-row', 'hb-suburb-row', 'hb-postcode-row'].forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.style.display = isPickup ? 'none' : '';
      var inp = el.querySelector('input');
      if (inp) inp.required = !isPickup;
    });
    var dateLabel = document.getElementById('hb-date-label');
    var dateNote = document.getElementById('hb-date-note');
    if (dateLabel) dateLabel.innerHTML = isPickup
      ? 'PICKUP DATE &amp; TIME <span class="hb-freq">*</span>'
      : 'DELIVERY DATE <span class="hb-freq">*</span>';
    if (dateNote) dateNote.textContent = isPickup
      ? 'Pickup available Monday to Saturday from Shop 7, Adelaide Arcade. Select your preferred time slot.'
      : 'Same-day delivery available if ordered before 12pm Monday–Friday. Saturday orders by Friday 12pm. Greater Adelaide delivery.';
    if (!isPickup) hbClearPickupSlot();
    if (isPickup) {
      hbSelectedZone = null; hbSelectedPrice = null;
    } else {
      hbSelectedZone = null; hbSelectedPrice = null;
      var suburbInput = document.getElementById('hb-suburb-input');
      if (suburbInput) suburbInput.value = '';
      var postcodeInput = document.getElementById('hb-postcode-field');
      if (postcodeInput) postcodeInput.value = '';
      var deliveryCost = document.getElementById('hb-delivery-cost');
      if (deliveryCost) deliveryCost.classList.remove('hb-show');
    }
    var cal = document.getElementById('hb-cal');
    if (cal) { cal.__hbRender && cal.__hbRender(); }
  }

  var hbCompletingLineKey = null;

  function hbCheckCompletingLine(callback) {
    var params = new URLSearchParams(window.location.search);
    var key = params.get('complete_line');
    if (!key) { callback(); return; }
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var match = cart.items.filter(function(item) { return item.key === key; })[0];
        if (match) {
          hbCompletingLineKey = key;
          var banner = document.createElement('div');
          banner.className = 'hb-fnote';
          banner.style.cssText = 'background:#fff4e5;border:1px solid #e8b96a;color:#6b4a1a;padding:10px 14px;margin-bottom:16px;';
          banner.textContent = 'Completing delivery details for the item already in your cart.';
          var formEl = document.getElementById('hb-order-form');
          if (formEl) formEl.prepend(banner);
        }
        callback();
      })
      .catch(function() { callback(); });
  }

  var hbQty = 1;
  function hbUpdateQty(delta) {
    hbQty = Math.max(1, hbQty + delta);
    var display = document.getElementById('hb-qty-display');
    var hidden = document.getElementById('hb-qty-value');
    if (display) display.textContent = hbQty;
    if (hidden) hidden.value = hbQty;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var suburbInput = document.getElementById('hb-suburb-input');
    if (suburbInput) suburbInput.addEventListener('input', function(e) { hbSuburbSearch(e.target.value); });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.hb-suburb-wrap')) {
        var dd = document.getElementById('hb-suburb-dropdown');
        if (dd) dd.style.display = 'none';
      }
    });

    document.querySelectorAll('.hb-del-btn').forEach(function(btn) {
      btn.addEventListener('click', function() { hbSetType(btn.dataset.type, btn); });
    });

    var minus = document.getElementById('hb-qty-minus');
    var plus = document.getElementById('hb-qty-plus');
    if (minus) minus.addEventListener('click', function() { hbUpdateQty(-1); });
    if (plus) plus.addEventListener('click', function() { hbUpdateQty(1); });

    hbCheckCompletingLine(function() {
      hbInitCal();
    });

    document.querySelectorAll('.hb-dform__addon-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.getAttribute('data-variant');
        if (!variantId || btn.disabled) return;
        btn.disabled = true;
        btn.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        }).then(function(r) {
          if (!r.ok) throw new Error();
          btn.textContent = 'Added ✓';
          btn.classList.add('hb-addon--added');
        }).catch(function() {
          btn.disabled = false;
          btn.textContent = 'Add';
        });
      });
    });

    var form = document.getElementById('hb-order-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Validate date and pickup time
        var dateHidden = document.getElementById('hb-delivery-date-value');
        var orderTypeEl = document.getElementById('hb-order-type');
        var isPickup = orderTypeEl && orderTypeEl.value === 'Pickup in Store';
        var slotHidden = document.getElementById('hb-pickup-time-value');
        var dateOk = dateHidden && dateHidden.value;
        var slotOk = !isPickup || (slotHidden && slotHidden.value);
        if (!dateOk || !slotOk) {
          var wrap = document.getElementById('hb-date-field-wrap');
          var err = document.getElementById('hb-date-error');
          if (!err) {
            err = document.createElement('span');
            err.id = 'hb-date-error';
            err.className = 'hb-fnote';
            err.style.color = 'var(--hb-accent)';
            err.textContent = !dateOk
              ? 'Please select a date before adding to cart.'
              : 'Please select a pickup time before adding to cart.';
            if (wrap) wrap.appendChild(err);
          }
          if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        // Validate suburb/zone is actually resolved (i.e. the customer clicked a
        // dropdown suggestion) before charging a delivery fee — don't allow a
        // delivery order to be added to cart with no zone/fee attached.
        if (!isPickup && !hbSelectedZone) {
          var suburbWrap = document.getElementById('hb-suburb-row');
          var suburbFieldInput = document.getElementById('hb-suburb-input');
          var zerr = document.getElementById('hb-suburb-error');
          if (!zerr) {
            zerr = document.createElement('span');
            zerr.id = 'hb-suburb-error';
            zerr.className = 'hb-fnote hb-fnote--error';
            zerr.textContent = 'Please select your suburb from the dropdown list before adding to cart.';
            if (suburbWrap) suburbWrap.appendChild(zerr);
          }
          if (suburbFieldInput) suburbFieldInput.classList.add('hb-finput--error');
          if (suburbWrap) suburbWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        // Collect all form properties via FormData
        var formData = new FormData(form);
        var properties = {};
        formData.forEach(function(val, key) {
          if (key.startsWith('properties[')) {
            properties[key.slice(11, -1)] = val;
          }
        });
        var bouquetVariantId = parseInt(formData.get('id'));

        // Disable button while submitting
        var submitBtn = form.querySelector('.hb-dform__submit');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

        function doCartChange(key, quantity, props) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity, properties: props })
          }).then(function(r) {
            if (!r.ok) throw new Error('cart change error');
          });
        }

        function doCartAddItems(items) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function(r) {
            if (!r.ok) throw new Error('cart add error');
          });
        }

        function finishSubmit(promise) {
          promise.then(function() {
            window.location = '/cart';
          }).catch(function() {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'ADD TO CART'; }
            var errEl = document.getElementById('hb-submit-error');
            if (!errEl) {
              errEl = document.createElement('p');
              errEl.id = 'hb-submit-error';
              errEl.className = 'hb-fnote';
              errEl.style.color = 'var(--hb-accent)';
              errEl.textContent = 'Something went wrong. Please try again.';
              form.querySelector('.hb-dform__submit-row').prepend(errEl);
            }
          });
        }

        var recipientName = properties['Recipient Full Name'] || '';
        var deliveryDate = properties['Delivery Date'] || '';
        var deliveryAddress = properties['Delivery Address'] || '';
        var postcode = properties['Postcode'] || '';
        var recipientKey = recipientName
          + (deliveryDate ? ' | ' + deliveryDate : '')
          + (deliveryAddress ? ' | ' + deliveryAddress : '')
          + (postcode ? ' | ' + postcode : '');

        var feeItems = [];
        if (!isPickup && hbSelectedZone) {
          var cal = document.getElementById('hb-cal');
          var rawFeeVariants = cal.dataset.feeVariants;
          var feeVariants = {};
          try { feeVariants = JSON.parse(rawFeeVariants || '{}'); } catch(e) {}
          var feeVariantId = feeVariants['Zone ' + hbSelectedZone];
          if (feeVariantId) {
            feeItems.push({
              id: feeVariantId,
              quantity: hbQty,
              properties: { _Recipient: recipientKey, _Zone: 'Zone ' + hbSelectedZone + ' — ' + hbSelectedPrice }
            });
          }
        }

        if (hbCompletingLineKey) {
          finishSubmit(
            doCartChange(hbCompletingLineKey, hbQty, properties).then(function() {
              return feeItems.length ? doCartAddItems(feeItems) : Promise.resolve();
            })
          );
        } else {
          var bouquetItem = { id: bouquetVariantId, quantity: hbQty, properties: properties };
          finishSubmit(doCartAddItems([bouquetItem].concat(feeItems)));
        }
      });
    }
  });

  function hbInitCal() {
    var wrap = document.getElementById('hb-cal');
    if (!wrap) return;

    var availStr = (wrap.dataset.avail || '').split(','); // Mon,Tue,Wed,Thu,Fri,Sat,Sun
    // Map to JS Date.getDay() order: 0=Sun,1=Mon,2=Tue,3=Wed,4=Thu,5=Fri,6=Sat
    var avail = [
      availStr[6] === 'true', // Sun (index 0)
      availStr[0] === 'true', // Mon
      availStr[1] === 'true', // Tue
      availStr[2] === 'true', // Wed
      availStr[3] === 'true', // Thu
      availStr[4] === 'true', // Fri
      availStr[5] === 'true'  // Sat
    ];
    var cutoffHour = parseInt(wrap.dataset.cutoff || '12', 10);
    var blackouts = (wrap.dataset.blackout || '').split(',').map(function(d) { return d.trim(); }).filter(Boolean);
    var pickupSlots = (wrap.dataset.pickupSlots || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    var now = new Date();
    var viewYear = now.getFullYear();
    var viewMonth = now.getMonth();
    var selectedDate = null;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function dateKey(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }

    function isAvailable(y, m, d) {
      var date = new Date(y, m, d);
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      if (date < today) return false;
      if (date.getTime() === today.getTime() && now.getHours() >= cutoffHour) return false;
      if (!avail[date.getDay()]) return false;
      if (blackouts.indexOf(dateKey(y, m, d)) !== -1) return false;
      return true;
    }

    function render() {
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
      var firstDow = new Date(viewYear, viewMonth, 1).getDay(); // 0=Sun
      var offset = (firstDow + 6) % 7; // Mon-based grid offset

      var html = '<div class="hb-cal-header">'
        + '<button type="button" class="hb-cal-nav" id="hb-cal-prev">‹</button>'
        + '<span class="hb-cal-month">' + months[viewMonth] + ' ' + viewYear + '</span>'
        + '<button type="button" class="hb-cal-nav" id="hb-cal-next">›</button>'
        + '</div><div class="hb-cal-grid">';

      ['M','T','W','T','F','S','S'].forEach(function(d) {
        html += '<div class="hb-cal-dow">' + d + '</div>';
      });
      for (var i = 0; i < offset; i++) html += '<div class="hb-cal-day hb-cal-day--empty"></div>';
      for (var day = 1; day <= daysInMonth; day++) {
        var key = dateKey(viewYear, viewMonth, day);
        var ok = isAvailable(viewYear, viewMonth, day);
        var sel = key === selectedDate;
        var cls = 'hb-cal-day' + (ok ? '' : ' hb-cal-day--off') + (sel ? ' hb-cal-day--selected' : '');
        html += '<div class="' + cls + '" data-date="' + key + '">' + day + '</div>';
      }
      html += '</div>';
      if (selectedDate) {
        html += '<div class="hb-cal-selected-label">Selected: ' + selectedDate + '</div>';
      }

      var orderTypeEl = document.getElementById('hb-order-type');
      var isPickup = orderTypeEl && orderTypeEl.value === 'Pickup in Store';
      if (isPickup && selectedDate && pickupSlots.length) {
        html += '<div class="hb-slots">';
        pickupSlots.forEach(function(slot) {
          var sel = slot === hbPickupSlot ? ' hb-slot--selected' : '';
          html += '<button type="button" class="hb-slot' + sel + '" data-slot="' + slot + '">' + slot + '</button>';
        });
        html += '</div>';
      }

      wrap.innerHTML = html;

      document.getElementById('hb-cal-prev').addEventListener('click', function() {
        viewMonth--; if (viewMonth < 0) { viewMonth = 11; viewYear--; } render();
      });
      document.getElementById('hb-cal-next').addEventListener('click', function() {
        viewMonth++; if (viewMonth > 11) { viewMonth = 0; viewYear++; } render();
      });
      wrap.querySelectorAll('.hb-cal-day:not(.hb-cal-day--off):not(.hb-cal-day--empty)').forEach(function(el) {
        el.addEventListener('click', function() {
          selectedDate = el.dataset.date;
          var hidden = document.getElementById('hb-delivery-date-value');
          if (hidden) hidden.value = selectedDate;
          hbPickupSlot = null;
          var slotHidden = document.getElementById('hb-pickup-time-value');
          if (slotHidden) slotHidden.value = '';
          var err = document.getElementById('hb-date-error');
          if (err) err.remove();
          render();
        });
      });
      wrap.querySelectorAll('.hb-slot').forEach(function(el) {
        el.addEventListener('click', function() {
          hbPickupSlot = el.dataset.slot;
          var slotHidden = document.getElementById('hb-pickup-time-value');
          if (slotHidden) slotHidden.value = hbPickupSlot;
          var err = document.getElementById('hb-date-error');
          if (err) err.remove();
          render();
        });
      });
    }

    wrap.__hbRender = render;
    render();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
